// extracted by css-extract-rspack-plugin
export default {"paragraph":"src-Paragraph-paragraph-29173434"};